import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fires a POST /api/analytics/pageview for every route change.
 * Fire-and-forget — failures are swallowed so they never block the UI.
 */
export default function usePageviewTracker() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = location.pathname + (location.hash || '');
    if (path === lastPath.current) return;
    lastPath.current = path;

    axios
      .post(`${API}/analytics/pageview`, { page: path })
      .catch(() => {
        /* analytics must never break the app */
      });
  }, [location.pathname, location.hash]);
}
